import { render, staticRenderFns } from "./MapLegendDialog.vue?vue&type=template&id=18d9e86f"
import script from "./MapLegendDialog.vue?vue&type=script&lang=js"
export * from "./MapLegendDialog.vue?vue&type=script&lang=js"
import style0 from "./MapLegendDialog.vue?vue&type=style&index=0&id=18d9e86f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports